export { default } from "./Pane";
